(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const lists = document.querySelectorAll('[data-sc-countup]');
    if (!lists.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const animate = (el) => {
      const raw = el.dataset.value || '';
      const target = parseInt(raw.replace(/[^0-9]/g, ''), 10);
      if (!Number.isFinite(target) || String(target) !== raw.trim()) return;
      const start = performance.now();
      const duration = 1800;
      const step = (now) => {
        const p = Math.min((now - start) / duration, 1);
        el.textContent = Math.round((1 - Math.pow(1 - p, 4)) * target);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      };
      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('.sc-stats__number').forEach(animate);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.3 });

    lists.forEach((list) => observer.observe(list));
  })();

  } catch(e) { console.error(e); }
})();
})();
